/**
 * FacetWP — inject labels and toggle visibility.
 *
 * jQuery is provided by WordPress as a global — no import needed.
 * Using an import would cause esbuild (IIFE format) to generate a
 * require() shim that throws in the browser, breaking label injection.
 *
 * FacetWP 4.x dispatches `facetwp-loaded` as a native CustomEvent, so all
 * listeners here bind natively (the inline scripts in inc/facetwp.php
 * already rely on native dispatch).
 *
 * @package foravida
 */

/* global jQuery */

(function () {
  'use strict';

  var facetCheckboxSelector = '.facetwp-checkbox[role="checkbox"]';

  /**
   * FacetWP's accessibility helper sets aria-checked when results are rendered,
   * but its delegated click handler only toggles the `checked` class. Keep the
   * exposed checkbox state aligned immediately for pointer and keyboard input,
   * and after an AJAX response replaces a facet's children.
   */
  function syncFacetCheckboxState(element) {
    if (
      !element ||
      element.nodeType !== 1 ||
      !element.matches(facetCheckboxSelector)
    ) {
      return;
    }

    var ariaChecked = element.classList.contains('checked') ? 'true' : 'false';
    if (element.getAttribute('aria-checked') !== ariaChecked) {
      element.setAttribute('aria-checked', ariaChecked);
    }
  }

  function syncFacetCheckboxStates(root) {
    if (!root) {
      return;
    }

    syncFacetCheckboxState(root);

    if (typeof root.querySelectorAll !== 'function') {
      return;
    }

    var checkboxes = root.querySelectorAll(facetCheckboxSelector);
    for (var i = 0; i < checkboxes.length; i++) {
      syncFacetCheckboxState(checkboxes[i]);
    }
  }

  syncFacetCheckboxStates(document);

  if (typeof MutationObserver !== 'undefined') {
    var facetStateObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'attributes') {
          syncFacetCheckboxState(mutation.target);
          continue;
        }

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          syncFacetCheckboxStates(mutation.addedNodes[j]);
        }
      }
    });

    facetStateObserver.observe(document.body || document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'role', 'aria-checked'],
    });
  }

  /* Inject facet labels above each facet. */
  document.addEventListener('facetwp-loaded', function () {
    if (!window.FWP || !window.FWP.settings) {
      return;
    }
    var labels = window.FWP.settings.labels || {};

    jQuery('.facetwp-facet').each(function () {
      var facet      = jQuery(this);
      var facetType  = facet.attr('data-type');
      var facetLabel = labels[facet.attr('data-name')];

      if (facetType === 'pager' || facetType === 'sort') {
        return;
      }
      if (
        facet.closest('.facet-wrap').length < 1 &&
        facet.closest('.facetwp-flyout').length < 1
      ) {
        facet.wrap('<div class="facet-wrap"></div>');
        // Skip the heading when no label is registered — never render
        // a literal "undefined" in the UI.
        if (typeof facetLabel === 'string' && facetLabel !== '') {
          var h3 = document.createElement('h3');
          h3.className = 'facet-label';
          h3.textContent = facetLabel; // textContent never parses HTML — avoids XSS sink.
          facet[0].parentNode.insertBefore(h3, facet[0]);
        }
      }
    });
  });

  /* Toggle facet visibility based on available choices. */
  document.addEventListener('facetwp-loaded', function () {
    if (!window.FWP || !window.FWP.settings || !window.FWP.settings.num_choices) {
      return;
    }
    jQuery.each(window.FWP.settings.num_choices, function (key, val) {
      var $facet  = jQuery('.facetwp-facet-' + key);
      var $wrap   = $facet.closest('.facet-wrap');
      var $flyout = $facet.closest('.flyout-row');

      if (!$wrap.length && !$flyout.length) {
        return;
      }
      var $which = $wrap.length ? $wrap : $flyout;
      if (val === 0) {
        $which.hide();
      } else {
        $which.show();
      }
    });
  });

  /* FacetWP replaces facet children during AJAX refreshes. */
  document.addEventListener('facetwp-loaded', function () {
    syncFacetCheckboxStates(document);
  });

  /* Re-hydrate Lucide icons in AJAX-injected results — createIcons only
     runs once on DOMContentLoaded (see foravida-lucide-init.js). */
  document.addEventListener('facetwp-loaded', function () {
    if (window.fvIcons && typeof window.fvIcons.refresh === 'function') {
      window.fvIcons.refresh();
    }
  });
})();
